export function calculateStrokePixels(points, canvasWidth, canvasHeight) {
    if (points.length < 2)
        return 0;
    let minX = Infinity, maxX = -Infinity;
    let minY = Infinity, maxY = -Infinity;
    for (const [x, y] of points) {
        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
    }
    const width = (maxX - minX) * canvasWidth;
    const height = (maxY - minY) * canvasHeight;
    return Math.max(width * height, 1);
}
export function calculateStrokeLength(points, canvasWidth, canvasHeight) {
    if (points.length < 2)
        return 0;
    let length = 0;
    for (let i = 1; i < points.length; i++) {
        const [x1, y1] = points[i - 1];
        const [x2, y2] = points[i];
        const dx = (x2 - x1) * canvasWidth;
        const dy = (y2 - y1) * canvasHeight;
        length += Math.sqrt(dx * dx + dy * dy);
    }
    return length;
}
export const DEFAULT_CHANNEL_CONFIG = {
    bitsPerPx: 0.0001,
    displayDurationMs: 30000,
    minBits: 10,
    maxBits: 5000,
    liveDrawingsPosition: 'right',
};
export const BITS_SKU_TIERS = [10, 25, 50, 100, 300, 500, 1000, 2000, 5000];
export function snapBitsToSkuTier(amount) {
    const match = BITS_SKU_TIERS.find((tier) => tier >= amount);
    return match ?? BITS_SKU_TIERS[BITS_SKU_TIERS.length - 1];
}
export function calculateBitsAmount(stroke, canvasWidth = 1920, canvasHeight = 1080, config = DEFAULT_CHANNEL_CONFIG) {
    const { bitsPerPx, minBits, maxBits } = config;
    const area = calculateStrokePixels(stroke.points, canvasWidth, canvasHeight);
    const areaWithWidth = area + (stroke.width * stroke.width);
    const rawBits = Math.ceil(areaWithWidth * bitsPerPx);
    return Math.min(Math.max(rawBits, minBits), maxBits);
}
export function calculateBatchBitsAmount(strokes, canvasWidth = 1920, canvasHeight = 1080, config = DEFAULT_CHANNEL_CONFIG) {
    if (strokes.length === 0) {
        return 0;
    }
    const { bitsPerPx, minBits, maxBits } = config;
    const allPoints = strokes.flatMap((stroke) => stroke.points);
    const xs = allPoints.map(([x]) => x);
    const ys = allPoints.map(([, y]) => y);
    const maxStrokeWidth = strokes.reduce((acc, stroke) => Math.max(acc, stroke.width), 0);
    const width = (Math.max(...xs) - Math.min(...xs)) * canvasWidth;
    const height = (Math.max(...ys) - Math.min(...ys)) * canvasHeight;
    const area = Math.max(width * height, 1);
    const areaWithWidth = area + (maxStrokeWidth * maxStrokeWidth);
    const rawBits = Math.ceil(areaWithWidth * bitsPerPx);
    return Math.min(Math.max(rawBits, minBits), maxBits);
}
export function calculateSubmissionBits(strokes, animation, canvasWidth = 1920, canvasHeight = 1080, config = DEFAULT_CHANNEL_CONFIG) {
    const frames = animation?.frames?.filter((frame) => frame.length > 0) ?? [];
    if (frames.length === 0) {
        return calculateBatchBitsAmount(strokes, canvasWidth, canvasHeight, config);
    }
    return frames.reduce((max, frame) => Math.max(max, calculateBatchBitsAmount(frame, canvasWidth, canvasHeight, config)), 0);
}
export function formatBitsAmount(bits) {
    return `${bits} Bit${bits !== 1 ? 's' : ''}`;
}
//# sourceMappingURL=pricing.js.map